import { Injectable } from '@angular/core';

@Injectable()
/**
 * Service for creating template configurations
 */
export abstract class TemplateConfigurationBaseService {

    constructor(
    ) {
    }

    /**
     * Gets a template configuration
     */
    public abstract getTemplateConfiguration();
}
